import { render, staticRenderFns } from "./ActionsModal.vue?vue&type=template&id=6879ae36&"
import script from "./ActionsModal.vue?vue&type=script&lang=js&"
export * from "./ActionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports